import { render, staticRenderFns } from "./StatsComment.vue?vue&type=template&id=0c8afc90&"
import script from "./StatsComment.vue?vue&type=script&lang=js&"
export * from "./StatsComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports